import React from "react"
import {Customer} from "../../resources/customer"
import {Account} from "../../resources/account"
import Assignments from "../Assignments/Assignments"
import {CheckDeposit} from "../../resources/checkDeposits"
import {AssignmentResourceType} from "../../resources/assignments"

export interface CheckDepositAssignmentsProps {
	checkDeposit: CheckDeposit
	included: Array<Account | Customer>
	frontImage: ArrayBuffer | null | undefined
	backImage: ArrayBuffer | null | undefined
	frontTiffImage?: ArrayBuffer | null
	backTiffImage?: ArrayBuffer | null
	expectsTiff?: boolean
	refreshToken: number
	refresh: () => void
}

export function CheckDepositAssignments({
	checkDeposit,
	included,
	frontImage,
	backImage,
	frontTiffImage,
	backTiffImage,
	expectsTiff,
	refreshToken,
	refresh,
}: CheckDepositAssignmentsProps) {
	return (
		<Assignments
			resource={checkDeposit}
			included={included}
			refreshToken={refreshToken}
			refresh={refresh}
			payload={{frontImage, backImage, frontTiffImage, backTiffImage, expectsTiff}}
			resourceTypes={[AssignmentResourceType.CheckDeposit]}
		/>
	)
}
